const $$splitComponentImporter = () => import('/app/src/routes/booking/finalize.$token.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/booking/finalize/$token")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
interface FinalizeMeta {
  sessionId: string;
  serviceName: string;
  therapistName: string;
  scheduledAt: string;
  amount: number;
  holdExpiresAt: string | null;
}
interface MonriResp {
  monri: MonriFormParams;
}

// The API returns "Rezervacija je već plaćena." with a 409 when the hold has
// already been settled — a good outcome for the client, not an error.